import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {ACTION_ICONS} from '../CreateTriggerDrawer/DrawerPageSummary';
import {DescriptionType} from '../utils';

type ViewTriggerEventActionSummaryProps = {
  descriptionDict: DescriptionType;
};

export const ViewTriggerEventActionSummary = ({
  descriptionDict,
}: ViewTriggerEventActionSummaryProps) => {
  const iconName =
    ACTION_ICONS[descriptionDict.actionType ?? 'QueueJobTriggeredAction'] ??
    'flash-bolt';
  return (
    <Tailwind style={{width: '100%'}}>
      <div className="min-h-130 mt-16 flex flex-row gap-8">
        <div className="w-4 rounded bg-teal-450" />
        <div className="flex w-full flex-col gap-8">
          <div className="border-1 m-h-65 flex w-full flex-row rounded border border-solid border-moon-250 px-12 py-8">
            <div className="mr-8 self-center p-10">
              <Icon name="recent-clock" />
            </div>
            <div className="flex-col">
              <div className="break-words text-base font-semibold text-moon-450">
                {descriptionDict.event.title}
              </div>
              <div className="break-words text-base font-normal">
                {descriptionDict.event.body}
              </div>
            </div>
          </div>
          <div className="border-1 m-h-65 flex w-full flex-row rounded border border-solid border-moon-250 px-12 py-8">
            <div className="mr-8 self-center break-all p-10">
              <Icon name={iconName} />
            </div>
            <div className="flex-col">
              <div className="break-all text-base font-semibold text-moon-450">
                {descriptionDict.action.title}
              </div>
              <div className="text-base font-normal">
                {descriptionDict.action.body}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Tailwind>
  );
};
